import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck, AlertCircle } from "lucide-react";
import Layout from "../components/Layout";
import { auth } from "../lib/api";

export default function AdminLogin() {
  const [bookingId, setBookingId] = useState("");
  const [lastName, setLastName] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const data = await auth.adminLogin(bookingId, lastName);
      auth.save(data);
      navigate(data.role === "master" ? "/master" : "/admin");
    } catch (e) {
      setErr(e?.response?.data?.detail || "No se pudo iniciar sesión");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <section className="min-h-[calc(100dvh-4rem)] flex items-center justify-center px-6 py-16">
        <div className="w-full max-w-md fade-up">
          <div className="text-center mb-10">
            <div className="inline-flex w-14 h-14 rounded-full bg-[var(--brand-cyan,#FF85AC)]/10 border border-[var(--brand-cyan,#FF85AC)]/30 items-center justify-center mb-6">
              <ShieldCheck className="w-5 h-5 text-[var(--brand-cyan,#FF85AC)]" strokeWidth={1.5} />
            </div>
            <p className="text-xs uppercase tracking-[0.4em] text-[var(--brand-cyan,#FF85AC)] mb-3">Acceso Operadores</p>
            <h1 className="font-display text-4xl font-light tracking-tight">Bienvenido de vuelta</h1>
            <p className="text-sm text-neutral-400 mt-3">Ingresa tu credencial de operador.</p>
          </div>

          <form onSubmit={submit} className="space-y-7 glass rounded-3xl p-8 border border-white/10">
            <div>
              <label className="text-[10px] uppercase tracking-[0.3em] text-neutral-500 block mb-2">
                ID de Operador
              </label>
              <input
                autoComplete="username"
                autoCapitalize="characters"
                autoCorrect="off"
                value={bookingId}
                onChange={(e) => setBookingId(e.target.value)}
                placeholder="ADMIN-001"
                data-testid="admin-id-input"
                className="w-full bg-transparent border-b border-white/15 focus:border-[var(--brand-cyan,#FF85AC)] outline-none py-3 text-white placeholder:text-neutral-700 transition-colors"
                required
              />
            </div>

            <div>
              <label className="text-[10px] uppercase tracking-[0.3em] text-neutral-500 block mb-2">
                Clave
              </label>
              <input
                type="password"
                autoComplete="current-password"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                placeholder="••••••"
                data-testid="admin-key-input"
                className="w-full bg-transparent border-b border-white/15 focus:border-[var(--brand-cyan,#FF85AC)] outline-none py-3 text-white placeholder:text-neutral-700 transition-colors"
                required
              />
            </div>

            {err && (
              <div className="flex items-start gap-2 text-sm text-[#FF3B30] bg-[#FF3B30]/10 border border-[#FF3B30]/30 rounded-xl p-3" data-testid="login-error">
                <AlertCircle className="w-4 h-4 mt-0.5 shrink-0" />
                <span>{err}</span>
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              data-testid="admin-login-submit-btn"
              className="w-full bg-[var(--brand-cyan,#FF85AC)] text-black py-3.5 rounded-full font-semibold tracking-wide hover:bg-[#FF9DC0] cyan-glow transition-all disabled:opacity-50"
            >
              {loading ? "Verificando…" : "Acceder como Admin"}
            </button>
          </form>
        </div>
      </section>
    </Layout>
  );
}
